module.exports = __webpack_public_path__ + "static/media/Mozlows-01-outline.ee42219f.svg";